import React from "react";
import Page, { PageProps } from "../Page";
import DataGrid from "../../components/app/grid/DataGrid";
import { Form } from "antd";
import { IBusinessRulesPresenter } from "../../../presenter/evaluation/BusinessRulesPresenter";
import CreateBusinessRuleForm, {
  CreateBusinessRuleFormProps
} from "./CreateBusinessRuleForm";
import UpdateBusinessRuleForm, {
  UpdateBusinessRuleFormProps
} from "./UpdateBusinessRuleForm";
import Loader from "../../components/Loader";
export interface Props extends PageProps {}
export interface State extends IBusinessRulesPresenter {}

export default class BusinessRulesPage extends React.Component<Props, State> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe(result => {
      return this.setState(() => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    let {
      translate,
      businessRules = [],
      createBusinessRule,
      updateBusinessRule
    } = this.state;
    const CreateForm = Form.create<CreateBusinessRuleFormProps>({})(
      CreateBusinessRuleForm
    );

    const UpdateForm = Form.create<UpdateBusinessRuleFormProps>({})(
      UpdateBusinessRuleForm
    );

    const columns = [
      {
        title: translate("businessRules_page.name"),
        dataIndex: "name",
        key: "name"
      },
      {
        title: translate("businessRules_page.description"),
        dataIndex: "description",
        key: "description"
      }
    ];

    const dataGrid = (
      <DataGrid
        title={translate("grids.business-rules")}
        translate={translate}
        columns={columns}
        dataSource={businessRules}
        allowCreate={true}
        allowDelete={false}
        allowUpdate={true}
        createForm={CreateForm}
        updateForm={UpdateForm}
        onCreate={createBusinessRule}
        onUpdate={updateBusinessRule}
        expandedRowRender={record => (
          <p
            style={{
              margin: 0,
              fontFamily: "Courier New",
              whiteSpace: "pre-wrap",
              width: "min-content"
            }}
          >
            {record.rule}
          </p>
        )}
        createModalTitle={translate("businessRules_page.insert_modal_title")}
        updateModalTitle={translate("businessRules_page.update_modal_title")}
        addButtonText={translate("businessRules_page.add_button_text")}
      />
    );

    return (
      <Page {...this.props}>
        <Loader
          children={dataGrid}
          translate={translate}
          loading={this.state.loaders.businessRulesLoader}
        />
      </Page>
    );
  }
}
